// extracted by mini-css-extract-plugin
export var addressFields = "_ia-0";
export var animationContainer = "_ia-1";
export var footer = "_ia-2";
export var lineItems = "_ia-3";
export var modalContent = "_ia-4";
export var orderName = "_ia-5";
export var strong = "_ia-6";
export var warning = "_ia-7";